import { getCurrentInstance } from 'vue'

/**
 * 尝试在作用域销毁时执行清理函数（Vue 2.7 兼容版）
 * @param fn 清理函数
 * @returns 是否成功注册清理函数（false 表示当前不在组件上下文中）
 */
export function tryOnScopeDispose(fn) {
  const instance = getCurrentInstance()
  if (!instance) {
    fn()
    return false
  }

  instance.proxy?.$once('hook:beforeDestroy', fn)
  return true
}
